import React from 'react';

/**
 * Pregnant figure drawn to Lucide's conventions (24-grid, 2px round stroke, no fill),
 * for the OB Anesthesia topic. Lucide and Tabler have no equivalent.
 */
const PregnantIcon = ({ className = 'w-6 h-6', strokeWidth = 2 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <circle cx="11" cy="4" r="2" />
    <path d="M9 22v-7" />
    <path d="M9 15V9.5A1.5 1.5 0 0 1 10.5 8h1A2.5 2.5 0 0 1 14 10.5V12a3.5 3.5 0 1 1-2 6.6" />
    <path d="M12 22v-3" />
  </svg>
);

export default PregnantIcon;
